import * as yup from "yup";
import i18next from "config/i18next";
import { InvoiceValidationSchemaCO } from "./types";

const requiredString = yup.string().required("");
const optionalString = yup.string().optional();

const invoiceNumber = (save: boolean) =>
  yup
    .string()
    .min(5, i18next.t("invoice:invoiceNumberError"))
    .concat(save ? optionalString : requiredString);

const invoiceType = (save: boolean) =>
  yup.object({
    name: yup.string().concat(save ? optionalString : requiredString),
  });

const emisionDate = (save: boolean) =>
  yup.string().test("requireDatePicker", "", (value) => (save ? true : !!value));

export const validationSchemaCO = (
  save: boolean
): yup.SchemaOf<InvoiceValidationSchemaCO> => {
  return yup.object({
    emisionDate: emisionDate(save),
    invoiceType: invoiceType(save),
    invoiceNumber: invoiceNumber(save),
  });
};
